export default "__VITE_ASSET__C1QH3u0m__"